var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"index-h2"},[_vm._v("合作伙伴")]),_c('div',{staticClass:"list"},_vm._l((_vm.img_list),function(src){return _c('el-image',{key:src,staticClass:"img hvr-grow",attrs:{"src":src}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }